import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { EmailAlreadyInUseError, HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  email: string;
};

export const sendAuthorisationCodeOnEmail = async (params: Params) => {
  const fetchURL = getM8AuthURL('sendAuthorisationCodeOnEmail');

  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 409) {
      throw new EmailAlreadyInUseError();
    }

    throw new HTTPResponseError(response);
  }
};
